import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import classnames from 'classnames';

// styles
const useStyles = makeStyles((theme) => ({
  dotBase: {
    width: 5,
    height: 5,
    backgroundColor: theme.palette.text.hint,
    borderRadius: '50%',
    transition: theme.transitions.create('background-color'),
  },
  dotLarge: {
    width: 8,
    height: 8,
  },
}));

function Dot({ size, color }) {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <div
      className={classnames(classes.dotBase, {
        [classes.dotLarge]: size === 'large',
        [classes.dotSmall]: size === 'small',
      })}
      style={{
        backgroundColor:
          color && theme.palette[color] && theme.palette[color].main,
      }}
    />
  );
}

Dot.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
};

export default Dot;
